import styled from 'styled-components/macro'

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

export const SuccessContent = styled.div``

export const SuccessTitle = styled.span`
  display: block;
  font-size: 64px;
  font-weight: 700;
  line-height: 64px;
  letter-spacing: -0.075em;
  color: rgb(192, 0, 0);
  margin-bottom: 25px;
`

export const SuccessSubTitle = styled.span`
  display: block;
  font-size: 26px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: -0.075em;
  color: rgb(192, 0, 0);
  margin-bottom: 25px;
  text-align: center;
`
